<template>
	<BaseModal
		class="api-error-modal"
		:modalTitle="title ? title : DEFAULT_DETAILS.TITLE"
		:showClose="false"
	>
		<div slot="modalBody">
			<FallBack
				:message="message ? message : DEFAULT_DETAILS.MESSAGE"
				:border="false"
				:transparentBackground="true"
				iconStyle="fal"
				icon="exclamation-triangle"
			/>
			<div class="additional-information">
				<span v-if="code !== null" class="error-code" data-test="errorCode">{{
					code
				}}</span>
				<span v-if="showDateTime" data-test="dateTime">{{ dateTime }}</span>
			</div>
		</div>
		<div slot="modalFooterButtons">
			<BaseButton
				color="blue"
				class="action-button"
				@onClick="actionButtonHandler"
				>{{ buttonLabel }}
			</BaseButton>
		</div>
	</BaseModal>
</template>

<script>
import BaseModal from '@/components/global/BaseModal.vue';
import BaseButton from '@/components/global/BaseButton.vue';
import FallBack from '@/components/global/FallBack.vue';
import { DEFAULT_DETAILS } from './constants';

export default {
	name: 'ErrorModal',
	components: {
		BaseModal,
		BaseButton,
		FallBack,
	},
	props: {
		buttonAction: {
			type: String,
			default: 'close',
		},
		buttonLabel: {
			type: String,
			default: 'Close',
		},
		code: {
			type: String,
			default: null,
		},
		showDateTime: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			default: null,
		},
		message: {
			type: String,
			default: null,
		},
	},
	methods: {
		actionButtonHandler() {
			this.$emit('actionClicked', {
				code: this.code,
				title: this.title,
				message: this.message,
				buttonLabel: this.buttonLabel,
				buttonAction: this.buttonAction,
			});
		},
	},
	computed: {
		dateTime() {
			const today = new Date();
			return today.toLocaleString();
		},
	},
	created() {
		this.DEFAULT_DETAILS = DEFAULT_DETAILS;
	},
};
</script>

<style scoped lang="scss">
.api-error-modal {
	overflow: hidden;

	/deep/ .modal-header {
		@include rem('padding-bottom', 14px);
	}

	/deep/ .modal-title {
		color: $text-base-color;
		font-size: $b360-font-size--large;
		line-height: 1.2;
	}

	.additional-information {
		color: darken($b360-color--gray__light, 10%);
		font-size: $b360-font-size--smaller;
		@include rem('margin', 0 18px);
	}

	.error-code {
		@include rem('margin-right', 9px);
	}

	.action-button {
		display: block;
		margin-left: auto;
		width: auto;

		@include phablet {
			width: 100%;
		}
	}
}
</style>
